export enum JobStatus {
  Complete = 0,
  Error = 1,
  Processing = 2,
  Wait = 3,
  Unknown = 4,
}

export interface JobStatusMessage {
  conversionId: string;
  fileId: string;
  jobId: string;
  status: JobStatus;
  fileName: string;
  fileSize: number;
}
